<template>
  <div class="returncontainer">
    <md-field class="other">
      <md-cell-item
        class="address"
        :title="addres.name + ' , ' + addres.mobile"
        :brief="addres.allname"
        arrow
        @click="$router.go(-1)"
      >
        <md-icon name="location" size="lg" slot="left"></md-icon>
      </md-cell-item>
    </md-field>
    <p style="font-size: 0.32rem;padding: 0.32rem;text-align: left">包裹明細</p>
    <md-field class="other">
      <div v-for="(item,index) in par" :key="index">
      <md-cell-item :title="'快遞單號:'+item.expressNumber" :addon="'計費重量:'+item.bulk+'KG'">
      </md-cell-item>
      </div>
<!--      <md-cell-item title="計費重量" :addon="par.bulk + 'KG'" no-border>-->
<!--      </md-cell-item>-->
    </md-field>
    <p style="font-size: 0.32rem;padding: 0.32rem;text-align: left">退貨費用</p>
    <md-field class="other">
      <md-cell-item title="快遞費" :addon="price + 'CNY'"> </md-cell-item>
      <md-cell-item
        title="超期費"
        :addon="timeOutPrice + 'CNY'"
        v-if="timeOutPrice > 0"
      >
      </md-cell-item>
    </md-field>
    <div class="bootomsubmit">
      <p>
        合计：<span>{{ price }} CNY</span>
      </p>
      <md-button
        :type="price > 0 ? 'warning' : 'disabled'"
        :loading="loading"
        size="small"
        inline
        style="height: 100%;width: 2rem"
        @click="summit"
      >
        提交
      </md-button>
    </div>
  </div>
</template>

<script>
import {
  Amount,
  Button,
  CellItem,
  Field,
  FieldItem,
  Icon,
  Toast
} from "mand-mobile";
export default {
  name: "return",
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [CellItem.name]: CellItem,
    [Icon.name]: Icon,
    [Amount.name]: Amount,
    [FieldItem.name]: FieldItem
  },
  data() {
    return {
      addres: {},
      par: [],
      price: "",
      timeOutPrice:0,
      loading: false
    };
  },
  activated() {
    this.addres = JSON.parse(this.$route.query.addres);
    this.par = JSON.parse(this.$route.query.des);
    console.log(this.par);
    this.appReback();
  },
  methods: {
    summit() {
      this.loading = true
      let exnumber=[]
      this.par.map(val=>{
        exnumber.push(val.id)
      })
      const par = {
        parcleIds: exnumber
      };
      this.http
        .APIASK(this.ports.parcelBack, "post", Object.assign(par, this.addres))
        .then(res => {
          localStorage.setItem("fleshpack", 1);
          localStorage.setItem("fleshorder", 1);
          localStorage.setItem("serfren", 1233);
          this.$router.replace({
            name: "Pay",
            query: {
              id: res.id,
              price: this.price
            }
          });
        })
        .catch(err => {
          this.loading = false;
        });
    },
    sum(arr,key) {
      var s = 0;
      arr.forEach(function (val, idx, arr) {
        s +=(val[key]?val[key]:0);
      }, 0);
      return s;
    },
    appReback() {
      this.timeOutPrice=this.sum(JSON.parse(this.$route.query.des),'timeOutPrice')
      console.log('timeOutPrice',this.timeOutPrice)
      console.log(JSON.parse(this.$route.query.des).timeOutPrice)
      this.http.APIASK(this.ports.appReback, "post", {}).then(res => {
        const allprice = parseFloat(
          Math.ceil(this.sum(JSON.parse(this.$route.query.des),'bulk')) * res.rebackPrice
        );
        console.log('allprice',allprice)
        this.price =( this.timeOutPrice+parseFloat(allprice)).toFixed(2);
      });
    }
  }
};
</script>

<style lang="less">
.returncontainer {
  .md-field {
    padding: 0 0.4rem;
  }
  .md-cell-item-body.multilines {
    padding: 0;
    display: flex;
    align-items: center;
  }

  .md-cell-item-content {
    text-align: left;
  }
  .bootomsubmit {
    width: 100%;
    height: 1rem;
    position: fixed;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 999;

    p {
      font-size: 0.38rem;
      color: #e51c23;
      padding-left: 0.32rem;

      span {
        font-size: 0.3rem;
      }
    }
  }
}
</style>
